import Vue from 'vue';
import Router from 'vue-router';

import Dashboard from './views/Dashboard.vue';
import UserProfile from './views/UserProfile.vue';
import Errors from './views/Errors.vue';
import Login from './views/Login.vue';
import Attendance from './views/Attendance.vue';
import Registration from './views/Registration.vue';
import UserList from './views/UserList.vue';
import UserForm from './views/UserForm.vue';
import PersonForm from './views/Person.vue';
import PersonList from './views/PersonList.vue';
import CardList from './views/CardList.vue';
import CardForm from './views/CardForm.vue';
import ChurchList from './views/ChurchList.vue';
import ChurchForm from './views/ChurchForm.vue';
import ReportList from './views/ReportList.vue';
import PersonReport from './reports/PersonReport.vue';
import AttendanceReport from './reports/AttendanceReport.vue';
import CircleAttendanceReport from './reports/CircleAttendanceReport.vue';
import CardLogReport from './reports/CardLogReport.vue';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL + 'prayer.admin/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/attendance',
      name: 'attendance',
      meta: { layout: 'attendance', requiresAuth: false },
      component: Attendance,
    },
    {
      path: '/registration',
      name: 'registration',
      meta: { layout: 'attendance', requiresAuth: false },
      component: Registration,
    },
    {
      path: '/login',
      name: 'login',
      meta: { layout: 'login', requiresAuth: false },
      component: Login,
    },
    {
      path: '/user-list',
      name: 'user-list',
      component: UserList,
      meta: { requiresAuth: true },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: { requiresAuth: true },
      component: Dashboard,
    },
    {
      path: '/errors',
      name: 'errors',
      meta: { requiresAuth: true },
      component: Errors,
    },
    {
      path: '/user-form',
      name: 'user-form',
      meta: { requiresAuth: true },
      component: UserForm,
    },
    {
      path: '/user-profile',
      name: 'user-profile',
      component: UserProfile,
      meta: { requiresAuth: true },
    },
    {
      path: '/person-form',
      name: 'person-form',
      meta: { requiresAuth: true },
      component: PersonForm,
    },
    {
      path: '/person-list',
      name: 'person-list',
      component: PersonList,
      meta: { requiresAuth: true },
    },
    {
      path: '/card-list',
      name: 'card-list',
      component: CardList,
      meta: { requiresAuth: true },
    },
    {
      path: '/card-form',
      name: 'card-form',
      component: CardForm,
      meta: { requiresAuth: true },
    },
    {
      path: '/church-list',
      name: 'church-list',
      component: ChurchList,
      meta: { requiresAuth: true },
    },
    {
      path: '/church-form',
      name: 'church-form',
      component: ChurchForm,
      meta: { requiresAuth: true },
    },
    {
      path: '/report-list',
      name: 'report-list',
      component: ReportList,
      meta: { requiresAuth: true },
    },
    {
      path: '/person-report',
      name: 'person-report',
      meta: { requiresAuth: true },
      component: PersonReport,
    },
    {
      path: '/attendance-report',
      name: 'attendance-report',
      meta: { requiresAuth: true },
      component: AttendanceReport,
    },
    {
      path: '/attendance-circle-report',
      name: 'attendance-circle-report',
      meta: { requiresAuth: true },
      component: CircleAttendanceReport,
    },
    {
      path: '/card-log-report',
      name: 'card-log-report',
      meta: { requiresAuth: true },
      component: CardLogReport,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.token === '' || store.state.token == null) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
